import React, {useContext} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AuthContext} from '../../contexts/auth/context';
import {AuthContextType} from '../../contexts/auth/types';
import {ScreenPaths} from '../../enums/screen-path';

interface Props {
  path: string;
  children: React.ReactNode;
}

/**
 * HOC for our public routes which need a token to access.
 */
const PublicRouteWithToken: React.FC<Props> = ({children, ...rest}) => {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({location}) =>
        !authContext.state.firebaseUser &&
        location.search &&
        location.search.split('?token=')[1] ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: ScreenPaths.Office,
              state: {from: location},
            }}
          />
        )
      }
    />
  );
};
export default PublicRouteWithToken;
